export default {
  data() {
    return {
      removeProject: {
        project: { ID: -1, Name: '' },
        modal: false,
      },
    };
  },
  methods: {
    /**
     * Show remove project modal.
     * @param project
     */
    showRemoveProjectModal(project) {
      this.removeProject.project = project;
      this.removeProject.modal = true;
    },
  },
};
